import type { ReactNode } from 'react';

import { ActionIcon, ThemeIcon } from '@mantine/core';
import { modals } from '@mantine/modals';

import { IconAlertCircle, IconEdit } from '@tabler/icons-react';

import { useNoticeContext } from '../../contexts/Notice.provider';

export function RectificationWrapper({ children }: { children: ReactNode }) {
  const { tender } = useNoticeContext();
  const openUpdateTenderDeadlineModal = () =>
    modals.openContextModal({
      modal: 'updateTenderDeadline',
      innerProps: {
        tenderId: tender.id,
        initialDeadline: tender.responseDeadline,
      },
      padding: 0,
      radius: 'lg',
    });
  if (tender.rectifications.length === 0) {
    return children;
  }

  return (
    <>
      <ThemeIcon size="sm" radius="xl" color="orange.1" c="orange.7">
        <IconAlertCircle size={16} />
      </ThemeIcon>
      {children}
      <ActionIcon
        size="sm"
        color="primary"
        onClick={() => openUpdateTenderDeadlineModal()}
      >
        <IconEdit stroke={2} />
      </ActionIcon>
    </>
  );
}
